<template>
  <DocumentViewerShell class="document-viewer" :document="item" :toolbar="toolbar" />
</template>

<script>
  import DocumentViewerShell from '@/features/Documents/viewer/DocumentViewerShell.vue';

  /**
   * Kept for its existing callers (`<DocumentViewer :item>`): a thin wrapper around the shared
   * viewer in features/Documents/viewer. New code uses DocumentViewerShell directly.
   * `item.viewRevisionId` shows an older version.
   */
  export default {
    name: 'DocumentViewer',
    components: { DocumentViewerShell },
    props: {
      item: { type: Object, default: null },
      toolbar: { type: String, default: 'compact' },
    },
  };
</script>

<style scoped>
  .document-viewer {
    width: 100%;
    height: 100%;
  }
</style>
